import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { monthLabel } from "@/components/AddToPlan";

export const PlannedTowns = () => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get("/plan/items").then((r) => setItems(r.data)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);
  if (!items?.length) return null;
  const move = (i, month) => api.patch(`/plan/items/${i.id}`, { month }).then(load).catch((e) => toast.error(errMsg(e)));
  const remove = (i) => api.delete(`/plan/items/${i.id}`).then(load).catch((e) => toast.error(errMsg(e)));
  const build = async (i) => {
    if (!window.confirm(`Queue ${i.town} to build tonight? It uses AI credit.`)) return;
    try { await api.post("/batches", { towns: [i.region ? `${i.town}, ${i.region}` : i.town], country: i.country, start: "tonight" }); await api.delete(`/plan/items/${i.id}`); toast.success(`${i.town} queued for tonight`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const months = [...new Set(items.map((i) => i.month))];
  return (
    <div className="mt-5 border-t border-[#E2D9CC] pt-4" data-testid="planned-towns">
      <p className="text-sm text-[#3B1B48] mb-2">Planned towns</p>
      {months.map((m) => (
        <div key={m} className="mb-3">
          <p className="text-[10px] uppercase tracking-[0.18em] text-[#8C827A] mb-1">{monthLabel(m)}</p>
          <ul className="grid sm:grid-cols-2 gap-2">{items.filter((i) => i.month === m).map((i) => {
            const tid = i.town.toLowerCase().replace(/\W+/g, "-");
            return (
              <li key={i.id} className="border border-[#E2D9CC] bg-white px-3 py-2 text-sm flex flex-wrap items-center gap-2" data-testid={`planned-${tid}`}>
                <span className="mr-auto"><span className="font-medium">{i.town}</span> <span className="text-xs text-[#8C827A]">{[i.region, i.country].filter(Boolean).join(", ")}{i.source === "request" ? ` · ${i.requests} request${i.requests === 1 ? "" : "s"}` : ""}</span></span>
                <input type="month" value={i.month} onChange={(e) => e.target.value && move(i, e.target.value)} data-testid={`planned-month-${tid}`} className="text-xs border border-[#E2D9CC] px-1 py-0.5" />
                <button onClick={() => build(i)} data-testid={`planned-build-${tid}`} className="text-xs bg-[#3B1B48] text-[#FAF7F2] px-2.5 py-1.5 hover:bg-[#2A1334]">Build tonight</button>
                <button onClick={() => remove(i)} data-testid={`planned-remove-${tid}`} className="text-[#8C827A] hover:text-red-700" aria-label="Remove"><Trash2 className="w-4 h-4" /></button>
              </li>);
          })}</ul>
        </div>))}
    </div>
  );
};
